import { render, staticRenderFns } from "./AddMagicModeButton.vue?vue&type=template&id=4d4c5466&"
import script from "./AddMagicModeButton.vue?vue&type=script&lang=js&"
export * from "./AddMagicModeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports